import Gallery from './Gallery'
import GalleryProductView from './GalleryProductView'
import YoutubeLoader from './YoutubeLoader'

// Image cropping (vuejs-clipper + rxjs) is only needed inside these
// components, so they are loaded on demand.
const Cropper = () => import('./Cropper')
const Clipper = () => import('./Clipper')
const UnClipper = () => import('./UnClipper')

function install(Vue) {
  Vue.component('Cropper', Cropper)
  Vue.component(Gallery.name, Gallery)
  Vue.component(GalleryProductView.name, GalleryProductView)
  Vue.component(YoutubeLoader.name, YoutubeLoader)
  Vue.component('Clipper', Clipper)
  Vue.component('UnClipper', UnClipper)
}

export default { install }
